import { render, staticRenderFns } from "./CollectionOfSection.vue?vue&type=template&id=65c617c4&scoped=true&"
import script from "./CollectionOfSection.ts?vue&type=script&lang=ts&"
export * from "./CollectionOfSection.ts?vue&type=script&lang=ts&"
import style0 from "./CollectionOfSection.scss?vue&type=style&index=0&id=65c617c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c617c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VDialog,VIcon,VProgressCircular,VRow,VTooltip})
